import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import format from 'date-format'
import { connect } from "react-redux";
// import { SubmissionError } from 'redux-form';
import Dashboard from './../components/Menu/Dashboard'
import PropTypes from 'prop-types';
import { getCustomerData } from "./../actions/customers";
import { generateCheckbook } from "./../actions/checkbooks";
import { sendRequest, getQRPayment } from "./../actions/transactions";
import DialogOptions from '../components/Complements/DialogOptions';
import DialogImage from '../components/Complements/DialogImage';
import CheckBookForm from '../components/CheckBook/CheckBookForm';
// import DialogOTPRequest from '../components/Complements/DialogOTPRequest';
// import sendRequest from '../components/Complements/sendRequest';

class CheckBookContainer extends Component {
    // para obtener la data del customer buscado
    state = { owner: '', cedule: '', alert: false, email: '', dateSelected: format.asString(new Date()), form: {}, alertQR: false, img: '', message: '', type: '' };
    handleSubmit = (values) => {
        const { email } = this.state
        const { cedule, imei, serie } = this.props.device
        let data = { emite: cedule, amount: values.amount, date: moment(values.dateSelected).format('YYYY/MM/DD'), serie, imei, emited: 'REQUEST', cedule: values.cedule, email, description: values.description }
        this.props.generateCheckbook(data).then(r => {
            if (r.payload) {
                const { data } = r.payload
                if (data) {
                    this.props.handleOpenSnack('Cheque realizado', 'success')
                    this.props.history.push('/')
                } else {
                    this.props.handleOpenSnack('Error al realizar solicitud', 'error')
                }
            }
        })
        /* this.setState({alertQR: false})
        this.setState({ alert: true, form: values }) */
    }
    handlePayType = (option) => {
        const { serie, imei} = this.props.device
        if (option === 'Cobrar') {
            return this.props.sendRequest(false, this.state.form.cedule,
                this.state.form.amount, this.state.email, this.props.device.cedule,
                'COBROS', this.state.form.description)
        } else if (option === 'QR') {
            return this.props.getQRPayment(serie, imei, this.state.form.cedule,
                this.state.form.amount, this.props.device.cedule, 'USERCOBRO', this.state.form.description)
                .then(({payload})=> {
                    this.setState({alert: false})
                    this.setState({ alertQR: true, img: payload.qr })
                    // this.renderAlertQR(true, payload.qr)
                })
        }
        
        
    }
    findCustomer = (value) => {
        const { customers } = this.props
        // let customer = {}
        if (customers.length === 0) {
            this.props.getCustomerData(value).then(r => {
                if (r.payload.message) {
                    // throw new SubmissionError(r.payload)
                    this.props.handleOpenSnack('Usuario no encontrado', 'error')
                } else {
                    const { first_name, second_name, surname, second_surname, cedule, email } = r.payload
                    let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
                    this.setState({ owner: Names, cedule, email })
                }
                // customer = r.payload
            }).catch( error => {
                //console.log('error de consulta ', error)
            })
        } else {
            const getCustomer = customers.find(customer => customer.cedule === value);
            if (getCustomer !== undefined) {
                const { first_name, second_name, surname, second_surname, cedule, email } = getCustomer
                let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
                this.setState({ owner: Names, cedule, email })
            } else {
                this.props.handleOpenSnack('Usuario no encontrado', 'error')
            }
            
        }
        // return customer
    }
    handleOnClick = () => {
        this.props.history.push('/customers')
    }
    handleOnSubmitSuccess = () => {
        //this.props.history.goBack()
    }
    handleOnCancel = () => {
        this.props.history.push('/')
    }

    renderBody = () => {    
        const { owner, cedule, alert, alertQR, img, dateSelected } = this.state   
        return  <div>
                    <CheckBookForm
                        classes = { this.props }
                        onSubmit = { this.handleSubmit }
                        onCancel = { this.handleOnCancel }
                        findCustomer = { this.findCustomer}
                        owner = { owner }
                        cedule = { cedule }
                        dateSelected = { dateSelected }
                        alert = { this.renderAlert(alert) }
                        QR = { this.renderAlertQR(alertQR, img) }/>
                </div>
    }
    renderAlert = (open) => {        
        if (open) {
            return <DialogOptions title = 'Tipo de pago' subTitle = '' handlePayType = { this.handlePayType } />
        } else {
            return <div></div>
        }
    }

    renderAlertQR = (OpenQR, img) => {
        if (OpenQR) {
            return <DialogImage title = 'Escanee el codigo' subTitle = ''
            image = {img}/>
        } else {
            return <div></div>
        }       
    }
    render() {
        return (
            <div>
                <Dashboard
                    title= "Cheques"
                    body = { this.renderBody() }
                    // info = { this.renderInfoBody() }
                    // chart = { this.renderChart() }
                    multiple = { false }
                />
            </div>
        );
    }
}

CheckBookContainer.propTypes = {
    user: PropTypes.object,
    handleOpenSnack: PropTypes.func.isRequired,
}

const mapState = (state) => {
    const customers = state.customers;
    const device = state.devices
    return { customers, device };
}

export default withRouter(connect(mapState, {
    getCustomerData,
    sendRequest,
    getQRPayment,
    generateCheckbook} )(CheckBookContainer));
// export default withRouter(PaymentContainer);